import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { AuthenticationService } from './authentication-service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    const xhr = req.clone({
      withCredentials: true,
    });
    return next.handle(xhr).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (
            err.status === 401 &&
            err.url &&
            !err.url.includes('auth/account') &&
            !err.url.includes('auth/authenticate') &&
            this.authService.isLoggedIn()
          ) {
            this.authService.logout();
          }
        },
      })
    );
  }
}
